import { Component } from '@angular/core';
import {ITableCellItem} from "../../../../../shared/shared/table/table-cell";
import {ITableColumn} from "../../../../../shared/shared/table/table-column";
import {IDocumentDto} from "../../../dto/document-listing.dto";

@Component({
  selector: 'app-category-column',
  templateUrl: './category-column.component.html',
  styleUrl: './category-column.component.scss'
})
export class CategoryColumnComponent implements ITableCellItem {
  dataItem: IDocumentDto;
  columnOptions: ITableColumn;

  get categoryName():string{
      return this.dataItem?.category?.category_name
        || this.dataItem?.categories?.[0]?.category_name
        || "";
  }
}
